import React, { useState } from "react";
import { Button, Typography, TextField, Box } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import MonthYearPicker from "./MonthYearPicker";
import PeriodFilter from "../../Components/Common/PeriodFilter";

const TopMenu = ({
  heading,
  selectedMonth,
  selectedYear,
  setSelectedMonth,
  setSelectedYear,
  setDrawerFilterOpen,
  filterApplied,
  searchQuery,
  setSearchQuery,
  fetchData,
  toggleData = [],
  handleToggle,
  selectedOption,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  width,
  selectedFacility,
  setSelectedFacility,
  facilityRequired = true,
}) => {
  // const [selectedFacility, setSelectedFacility] = useState([]);
  // Sync selectedOption with URL if necessary (optional)
  const generateYearList = (startYear = 2013) => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = startYear; year <= currentYear; year++) {
      years.push(year);
    }
    return years;
  };
  const yearList = generateYearList(2013);

  return (
    <Box
      sx={{
        width: "100%",
        margin: "1rem 0",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          margin: "2rem 0",
          alignItems: "center",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            color: "black",
          }}
        >
          {/* {heading} {selectedOption ? `(${selectedOption})` : ""} */}
          {heading}
        </Typography>

        {/* <PeriodFilter
          {...{
            fromDate,
            setFromDate,
            toDate,
            setToDate,
            yearList,
            setSelectedFacility,
            selectedFacility,
            facilityRequired,
          }}
        /> */}
      </Box>
      <Box
        sx={{
          marginTop: "1rem",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: "1rem",
          }}
        >
          {toggleData.map((el) => (
            <Button
              variant="contained"
              onClick={() => handleToggle(el.title, el.url, el.approvalUrl)}
              sx={{
                backgroundColor:
                  selectedOption === el.title ? "#488257" : "#fff",
                color: selectedOption === el.title ? "#FFF" : "black",
                borderRadius: "12px 12px 0px 0px",
                fontSize: "14px",
                fontWeight: "400",
                fontFamily: "Inter",
                textTransform: "none",
                width: width ? width : "auto",
                "&:hover": {
                  backgroundColor:
                    selectedOption === el.title ? "#488257" : "#FFF",
                },
              }}
            >
              {el.title}
            </Button>
          ))}
        </Box>
        {/* <TextField
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") fetchData();
          }}
          placeholder="🔍 Search"
          fullWidth
          size="small"
          variant="outlined"
          sx={{
            backgroundColor: "#FFFFFF",
            borderRadius: "4px",
            width: "25%",
            height: "2.5rem",
          }}
        /> */}
      </Box>
    </Box>
  );
};

export default TopMenu;
